
import React from 'react';
import { Send, Mail, MapPin } from 'lucide-react';
import { Translation } from '../types';

interface ContactProps {
  t: Translation['contact'];
}

export const Contact: React.FC<ContactProps> = ({ t }) => {
  return (
    <footer id="contact" className="py-20 bg-gradient-to-b from-slate-900 to-slate-950 border-t border-slate-800">
      <div className="container mx-auto px-4">
        
        <div className="bg-blue-600 rounded-3xl p-10 md:p-16 text-center max-w-4xl mx-auto shadow-2xl relative overflow-hidden">
           {/* Abstract pattern */}
           <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
           <div className="absolute bottom-0 left-0 w-64 h-64 bg-black/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>

           <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 relative z-10">{t.title}</h2>
           <p className="text-blue-100 text-lg mb-10 max-w-xl mx-auto relative z-10">{t.desc}</p>
           
           <a 
             href="https://t.me/ksiuiwi552" 
             target="_blank"
             rel="noopener noreferrer"
             className="inline-flex items-center gap-2 bg-white text-blue-600 px-8 py-4 rounded-xl font-bold text-lg hover:bg-blue-50 transition-colors shadow-lg relative z-10"
             aria-label="Contact support on Telegram"
           >
             <Send size={20} />
             {t.telegramParams}
           </a>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left border-t border-slate-800 pt-10">
          <div>
            <div className="font-bold text-white text-lg mb-4">CloudResell Pro</div>
            <p className="text-slate-500 text-sm">
              Premium cloud solutions for businesses and individuals. Secure, anonymous, and reliable verified cloud accounts provider.
            </p>
          </div>
          
          <div className="flex flex-col gap-3">
             <div className="font-bold text-white mb-2">Contact Us</div>
             <a href="https://t.me/ksiuiwi552" className="flex items-center gap-2 text-slate-400 hover:text-white justify-center md:justify-start" aria-label="Telegram Support">
               <Send size={16} /> @ksiuiwi552
             </a>
             <a href="mailto:support@iyun.io" className="flex items-center gap-2 text-slate-400 hover:text-white justify-center md:justify-start" aria-label="Email Support">
               <Mail size={16} /> support@iyun.io
             </a>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-bold text-white mb-2">Legal Information</div>
            <a href="#" className="text-slate-400 hover:text-white text-sm">Terms of Service</a>
            <a href="#" className="text-slate-400 hover:text-white text-sm">Privacy Policy</a>
            <a href="#" className="text-slate-400 hover:text-white text-sm">Refund Policy</a>
          </div>
        </div>

        <div className="text-center text-slate-600 text-sm mt-10">
          © {new Date().getFullYear()} CloudResell Pro. All rights reserved. Professional Cloud Reselling Services.
        </div>

      </div>
    </footer>
  );
};

